import React from 'react';

type HTMLParserProps = { htmlString: string };

const HTMLParser = ({ htmlString }: HTMLParserProps) => (
  <div dangerouslySetInnerHTML={{ __html: htmlString }} />
);

export default HTMLParser;
